module.exports = __webpack_public_path__ + "img/05.0225ddab.jpg";